module.exports = require('./dist/client').default;



/*****************
 ** WEBPACK FOOTER
 ** ./~/@storybook/core/client.js
 ** module id = 580
 ** module chunks = 0
 **/